(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[736],{

/***/ 887546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PhoneIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function PhoneIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 21.111,
        height: props.size || 21.111,
        viewBox: "0 0 21.111 21.111"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19.417 13.857a11.986 11.986 0 01-3.764-.6 1.721 1.721 0 00-1.673.353l-2.374 1.79a13.118 13.118 0 01-5.9-5.9l1.741-2.307a1.706 1.706 0 00.42-1.729 12 12 0 01-.6-3.77A1.7 1.7 0 005.571 0H1.694A1.7 1.7 0 000 1.694a19.439 19.439 0 0019.417 19.417 1.7 1.7 0 001.694-1.694v-3.866a1.7 1.7 0 00-1.694-1.694z",
            fill: props.color
        })
    }));
}


/***/ }),

/***/ 970870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ WhatsAppIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function WhatsAppIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 34.886,
        height: props.size || 34.886,
        viewBox: "0 0 34.886 34.886"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0 0h34.886v34.886H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.444 30.611h-.029a13.41 13.41 0 01-7.207-2.121l-4.991 1.3 1.338-4.851-.318-.5a13.134 13.134 0 01-2.018-7c0-11.7 14.3-17.554 22.575-9.283 8.256 8.179 2.46 22.455-9.35 22.455z",
                fill: "#1e9848",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.684 20.702l-.012.1c-.4-.2-2.352-1.154-2.715-1.286-.816-.3-.586-.048-2.152 1.746-.233.26-.464.279-.86.1a10.8 10.8 0 01-3.2-1.976 12.074 12.074 0 01-2.209-2.755c-.39-.673.426-.769 1.168-2.175a.732.732 0 00-.033-.7c-.1-.2-.894-2.156-1.227-2.936s-.648-.679-.894-.679a1.981 1.981 0 00-1.821.458c-2.148 2.361-1.606 4.8.232 7.386 3.612 4.727 5.536 5.6 9.055 6.806a5.506 5.506 0 002.5.161 4.1 4.1 0 002.683-1.9 3.294 3.294 0 00.24-1.9c-.1-.18-.359-.279-.759-.459z",
                fill: "#fff"
            })
        ]
    }));
}


/***/ }),

/***/ 995350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ItemSchedulingInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./src/assets/svgExports/DateIcon.js

var DateIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_4_1343)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.66667 10H6.5C5.85658 10 5.33333 10.5232 5.33333 11.1667V12.3333C5.33333 12.9767 5.85658 13.5 6.5 13.5H7.66667C8.31008 13.5 8.83333 12.9767 8.83333 12.3333V11.1667C8.83333 10.5232 8.31008 10 7.66667 10ZM6.5 12.3333V11.1667H7.66667V12.3333H6.5ZM14.0833 4.16667H13.5V3.58333C13.5 3.26133 13.2392 3 12.9167 3C12.5941 3 12.3333 3.26133 12.3333 3.58333V4.16667H7.66667V3.58333C7.66667 3.26133 7.40592 3 7.08333 3C6.76075 3 6.5 3.26133 6.5 3.58333V4.16667H5.91667C4.30842 4.16667 3 5.47508 3 7.08333V14.0833C3 15.6916 4.30842 17 5.91667 17H14.0833C15.6916 17 17 15.6916 17 14.0833V7.08333C17 5.47508 15.6916 4.16667 14.0833 4.16667ZM5.91667 5.33333H14.0833C15.0482 5.33333 15.8333 6.1185 15.8333 7.08333V7.66667H4.16667V7.08333C4.16667 6.1185 4.95183 5.33333 5.91667 5.33333ZM14.0833 15.8333H5.91667C4.95183 15.8333 4.16667 15.0482 4.16667 14.0833V8.83333H15.8333V14.0833C15.8333 15.0482 15.0482 15.8333 14.0833 15.8333Z",
                    fill: "#4E4E4E"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4_1343",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(3 3)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var svgExports_DateIcon = (DateIcon);

;// CONCATENATED MODULE: ./src/assets/svgExports/TimeIcon.js

var TimeIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.5591 13.3357L13.3357 12.5591L10.5526 9.776V6.31579H9.44737V10.2238L12.5591 13.3357ZM10.0013 17C9.03308 17 8.12302 16.8163 7.2711 16.4488C6.41919 16.0814 5.67818 15.5827 5.04805 14.9529C4.41793 14.323 3.91903 13.5823 3.55134 12.7307C3.18378 11.8792 3 10.9694 3 10.0013C3 9.03308 3.18372 8.12302 3.55116 7.2711C3.9186 6.41919 4.41725 5.67818 5.04713 5.04805C5.67701 4.41793 6.41772 3.91903 7.26926 3.55134C8.12081 3.18378 9.03062 3 9.99871 3C10.9669 3 11.877 3.18372 12.7289 3.55116C13.5808 3.9186 14.3218 4.41725 14.9519 5.04713C15.5821 5.67701 16.081 6.41772 16.4487 7.26926C16.8162 8.12081 17 9.03062 17 9.99871C17 10.9669 16.8163 11.877 16.4488 12.7289C16.0814 13.5808 15.5827 14.3218 14.9529 14.9519C14.323 15.5821 13.5823 16.081 12.7307 16.4487C11.8792 16.8162 10.9694 17 10.0013 17ZM10 15.8947C11.6333 15.8947 13.0241 15.3206 14.1724 14.1724C15.3206 13.0241 15.8947 11.6333 15.8947 10C15.8947 8.36667 15.3206 6.97588 14.1724 5.82763C13.0241 4.67939 11.6333 4.10526 10 4.10526C8.36667 4.10526 6.97588 4.67939 5.82763 5.82763C4.67939 6.97588 4.10526 8.36667 4.10526 10C4.10526 11.6333 4.67939 13.0241 5.82763 14.1724C6.97588 15.3206 8.36667 15.8947 10 15.8947Z",
            fill: "#4E4E4E"
        })
    });
};
/* harmony default export */ var svgExports_TimeIcon = (TimeIcon);

// EXTERNAL MODULE: ./src/components/ProductScheduler/utils.ts
var utils = __webpack_require__(897713);
;// CONCATENATED MODULE: ./src/components/ItemSchedulingInfo/index.tsx




var ItemSchedulingInfo = function(param) {
    var schedulingInfo = param.schedulingInfo, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _headingClasses = param.headingClasses, headingClasses = _headingClasses === void 0 ? "" : _headingClasses, _paraClasses = param.paraClasses, paraClasses = _paraClasses === void 0 ? "" : _paraClasses;
    var ref = schedulingInfo || {}, date = ref.date, time = ref.time;
    var infoList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_DateIcon, {}),
            infoName: "Date",
            infoData: date || ""
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_TimeIcon, {}),
            infoName: "Slot time",
            infoData: (time === null || time === void 0 ? void 0 : time.from) && (time === null || time === void 0 ? void 0 : time.to) ? "".concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.from), " - ").concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.to)) : ""
        }, 
    ];
    return !!date && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[12px] tw-pb-[8px] tw-pt-[24px] ".concat(customClasses),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-flex tw-text-[14px]/[15px]  tw-font-normal ".concat(headingClasses),
                children: "Booking details"
            }),
            infoList.map(function(info, index) {
                return !!info.infoData && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-[8px] tw-text-[12px]/[15px] tw-font-normal  tw-text-[#4E4E4E] ".concat(paraClasses),
                    children: [
                        info.icon,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "tw-flex tw-items-center tw-gap-[4px]",
                            children: [
                                info.infoName,
                                ":",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-flex tw-items-center tw-font-normal tw-text-[#6B6B6B]",
                                    children: info.infoData
                                })
                            ]
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var components_ItemSchedulingInfo = (ItemSchedulingInfo);


/***/ }),

/***/ 719976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _utils_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(942194);



var ReadMoreReadLess = function(param) {
    var text = param.text, color = param.color, maxChar = param.maxChar;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isReadMore = ref[0], setIsReadMore = ref[1];
    var toggleReadMore = function() {
        return setIsReadMore(!isReadMore);
    };
    var isLongText = (text === null || text === void 0 ? void 0 : text.length) > (maxChar !== null && maxChar !== void 0 ? maxChar : _utils_constant__WEBPACK_IMPORTED_MODULE_2__/* .READ_MORE_TEXT_LIMIT */ .d);
    var displayedText = isReadMore && isLongText ? "".concat(text === null || text === void 0 ? void 0 : text.substring(0, maxChar || _utils_constant__WEBPACK_IMPORTED_MODULE_2__/* .READ_MORE_TEXT_LIMIT */ .d), "...") : text;
    var toggleText = isReadMore ? "Read More" : "Read Less";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "tw-break-all tw-text-[0.75rem] tw-font-normal tw-leading-4 md:tw-text-[0.875rem] tw-text-[".concat(color, "] ").concat(maxChar ? "md:tw-text-[12px]" : "md:tw-text-[0.875rem]"),
        children: [
            displayedText,
            isLongText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                onClick: toggleReadMore,
                className: "tw-cursor-pointer tw-text-[0.75rem] tw-font-medium tw-text-[#0E0E0E] tw-underline md:tw-text-[0.875rem] ".concat(isReadMore ? "" : "tw-pl-[6px]"),
                children: toggleText
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReadMoreReadLess);


/***/ }),

/***/ 942194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ READ_MORE_TEXT_LIMIT; },
/* harmony export */   "f": function() { return /* binding */ OPERATION_TYPE; }
/* harmony export */ });
var READ_MORE_TEXT_LIMIT = 50;
var OPERATION_TYPE = {
    ADD: "add",
    INC: "inc",
    DEC: "dec",
    SAVE: "save"
};


/***/ }),

/***/ 897713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pi": function() { return /* binding */ parseFormattedDate; },
/* harmony export */   "YZ": function() { return /* binding */ convertTo12HourFormat; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(730381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

function formatDate(date) {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()(date).format("Do MMMM, YYYY");
}
function parseFormattedDate(formattedDate) {
    if (!formattedDate) {
        return null;
    }
    var date = moment__WEBPACK_IMPORTED_MODULE_0___default()(formattedDate, "Do MMMM, YYYY", true);
    return date.isValid() ? date.toDate() : null;
}
function convertTo12HourFormat(time24) {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()(time24, "HH:mm").format("h:mm A");
}


/***/ }),

/***/ 179220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GlobalCfeLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _globalLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(325480);


var GlobalCfeLoader = function(param) {
    var type = param.type, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_globalLoader__WEBPACK_IMPORTED_MODULE_1__/* .GlobalLoader */ .k, {
        type: type,
        color: color
    });
};


/***/ }),

/***/ 533350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_OrderStatus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/url-search-params-polyfill/index.js
var url_search_params_polyfill = __webpack_require__(35449);
// EXTERNAL MODULE: ./src/components/DesktopPaymentModal/index.js + 3 modules
var DesktopPaymentModal = __webpack_require__(757909);
;// CONCATENATED MODULE: ./src/components/OrderStatusLoader/index.js


var OrderStatusLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "order-status-loader",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "loading-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left-wrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loading-block header-block load-animate"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "right-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-block load-animate"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-block small load-animate"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "loading-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left-wrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loading-block header-block load-animate"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "right-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-block load-animate"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-block small load-animate"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "loading-container noborder",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left-wrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loading-block header-block load-animate"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "right-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-block load-animate"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-block small load-animate"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_OrderStatusLoader = (OrderStatusLoader);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(730381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/containers/OrderStatus/components/B2bRfqDetailField.js


var B2bRfqDetailField = function(param) {
    var fieldkey = param.fieldkey, value = param.value, isFirstElement = param.isFirstElement, isLastElement = param.isLastElement;
    var getB2bRfqDetailFieldLabel = function(fieldkey) {
        switch(fieldkey){
            case "name":
                return "Full Name";
            case "phone":
                return "Phone number";
            case "email":
                return "Email Id";
            case "custom_message":
                return "Your message";
            case "address":
                return "Address";
            case "date_and_time":
                return "Date and Time";
            case "gst":
                return "GST";
            default:
                return "";
        }
    };
    var getModifiedDateFormat = function(dateValue) {
        var date = new Date(dateValue);
        var options = {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        };
        var formattedDate = date.toLocaleString("en-US", options);
        var modifiedDate = formattedDate.replace(/(\d+)(\/)(\w+)(\/)(\d+)(\s)(\d+):(\d+)\s(.+)/, "$3 $1, $5, $7:$8 $9");
        return moment_default()(modifiedDate).format("h:mm A, DD MMM, YYYY");
    };
    if (!value) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            borderBottom: !isLastElement ? "1.16944px dashed #9C9FAA" : ""
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mv0",
                style: {
                    width: "50%",
                    color: "#9C9FAA",
                    fontSize: 14,
                    fontWeight: 400,
                    padding: isFirstElement ? "8px 0px 18px 0px" : "18px 0px"
                },
                children: [
                    getB2bRfqDetailFieldLabel(fieldkey),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mv0",
                style: {
                    width: "50%",
                    color: "#000000",
                    fontSize: 14,
                    fontWeight: 400,
                    textAlign: "right",
                    padding: isFirstElement ? "8px 0px 18px 0px" : "18px 0px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                children: fieldkey === "date_and_time" ? getModifiedDateFormat(value) : value
            })
        ]
    });
};
/* harmony default export */ var components_B2bRfqDetailField = (B2bRfqDetailField);

// EXTERNAL MODULE: ./src/redux/actions/order.js
var order = __webpack_require__(804160);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/utils/getContactDetails.js
var getContactDetails = __webpack_require__(160492);
;// CONCATENATED MODULE: ./src/containers/OrderStatus/components/CancelOrderModal.js






var CancelOrderModal = function(param) {
    var showCancellationOptions = param.showCancellationOptions, setShowCancellationModal = param.setShowCancellationModal, setShowMoreOptions = param.setShowMoreOptions, setIsCancelModalOpen = param.setIsCancelModalOpen;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), selectedMessageValue = ref[0], setSelectedMessageValue = ref[1];
    var ref1 = (0,react.useState)(""), customReason = ref1[0], setCustomReason = ref1[1];
    var ref2 = (0,react.useState)(false), showNextModal = ref2[0], setShowNextModal = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return {
            orderDetails: state.orderReducer.orderDetails,
            storeData: state.storeReducer.store
        };
    }), orderDetails = ref3.orderDetails, storeData = ref3.storeData;
    var handleClose = function() {
        setShowCancellationModal(false);
        setIsCancelModalOpen(false);
    };
    var handleChange = function(reason) {
        setSelectedMessageValue(reason);
    };
    var handleSubmit = function() {
        if (selectedMessageValue === "Other" && customReason.length < 10) {
            return;
        }
        var payload = {
            id: orderDetails.order_id,
            text: selectedMessageValue === "Other" ? customReason : selectedMessageValue
        };
        dispatch((0,order/* cancelOrder */.sl)(payload));
        dispatch((0,order/* fetchOrderDetailByID */.GW)({
            order_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id
        }));
        setShowCancellationModal(false);
        setShowMoreOptions(false);
        window.location.reload();
    };
    var storePhone = (0,getContactDetails/* getVisibleStorePhone */.qQ)(storeData);
    var msgValues = [
        "Incorrect items ordered",
        "Ordered by mistake",
        "Want to change variant",
        "Item(s) not required anymore",
        "Other", 
    ];
    var isPrepaid = (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.payment_status) == 9;
    var handleNext = function() {
        if (isPrepaid) {
            setShowNextModal(true);
        } else {
            handleSubmit();
        }
    };
    if (checkClientDeviceType/* IS_MOBILE */.q$) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cancel-option-modal-overlay-mobile",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cancel-option-modal-mobile",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cancel-modal-main-heading-mobile",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cancel-modal-heading-text-mobile",
                            children: "Cancel Order"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "lazy",
                            src: "https://cdn.dotpe.in/longtail/social_media_templates/7612844/DL67whIR.jpeg",
                            className: "cancel-icon-mobile",
                            alt: "cancel",
                            onClick: handleClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cancel-modal-body-mobile",
                    children: [
                        !showNextModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cancel-modal-description-mobile",
                                    children: "Please tell us the correct reason for cancellation. This information is only used to improve our service."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cancel-modal-options-mobile",
                                    children: msgValues.map(function(reason, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cancel-modal-option-mobile",
                                            onClick: function() {
                                                return handleChange(reason);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    checked: selectedMessageValue === reason,
                                                    value: reason
                                                }, index),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    children: reason
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                selectedMessageValue === "Other" && /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                    name: "custom-reason",
                                    value: customReason,
                                    onChange: function(e) {
                                        return setCustomReason(e.target.value);
                                    },
                                    placeholder: "Describe any other reasons",
                                    className: "custom-cancel-input-box-mobile",
                                    maxLength: 40,
                                    rows: 7
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "cancel-order-btn-mobile".concat(selectedMessageValue.length > 0 && selectedMessageValue !== "Other" || selectedMessageValue === "Other" && customReason.length >= 10 ? "-selected" : ""),
                                    onClick: handleNext,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cancel-order-btn-txt-mobile".concat(selectedMessageValue.length > 0 && selectedMessageValue !== "Other" || selectedMessageValue === "Other" && customReason.length >= 10 ? "-selected" : ""),
                                        children: isPrepaid ? "Next" : "Submit and cancel order"
                                    })
                                })
                            ]
                        }),
                        showNextModal && isPrepaid && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cancel-next-modal-mobile",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cancel-next-modal-description-mobile",
                                    children: [
                                        "Your order will be cancelled.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Refund will be issued manually by the merchant. For quicker help, contact:",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontWeight: "bold",
                                                fontSize: "1rem"
                                            },
                                            children: storePhone
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "cancel-order-btn-mobile-selected",
                                    onClick: handleNext,
                                    style: {
                                        marginTop: "2rem"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cancel-order-btn-txt-mobile-selected",
                                        children: "Submit and cancel order"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cancel-option-modal-overlay",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            open: showCancellationOptions,
            fullWidth: true,
            className: "cancel-option-modal",
            maxWidth: "sm",
            onClose: handleClose,
            children: [
                !showNextModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cancel-modal-static",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cancel-modal-headings",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cancel-modal-main-heading",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cancel-modal-heading-text",
                                                    children: "Cancel Order"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    loading: "lazy",
                                                    src: "https://cdn.dotpe.in/longtail/social_media_templates/7612844/DL67whIR.jpeg",
                                                    className: "cancel-icon",
                                                    alt: "cancel",
                                                    onClick: handleClose
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cancel-modal-description",
                                            children: "Please tell us the correct reason for cancellation. This information is only used to improve our service."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cancel-modal-options-box",
                                    children: msgValues.map(function(reason, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cancel-modal-option",
                                            onClick: function() {
                                                return handleChange(reason);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    checked: selectedMessageValue === reason,
                                                    value: reason,
                                                    minLength: 10
                                                }, index),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    children: reason
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        }),
                        selectedMessageValue === "Other" && /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            name: "custom-reason",
                            value: customReason,
                            onChange: function(e) {
                                return setCustomReason(e.target.value);
                            },
                            placeholder: "Describe any other reasons",
                            className: "custom-cancel-input-box",
                            maxLength: 40
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cancel-order-div".concat(selectedMessageValue.length > 0 && selectedMessageValue !== "Other" || selectedMessageValue === "Other" && customReason.length >= 10 ? "-selected" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "cancel-order-btn".concat(selectedMessageValue.length > 0 && selectedMessageValue !== "Other" || selectedMessageValue === "Other" && customReason.length >= 10 ? "-selected" : ""),
                                onClick: handleNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cancel-order-btn-txt".concat(selectedMessageValue.length > 0 && selectedMessageValue !== "Other" || selectedMessageValue === "Other" && customReason.length >= 10 ? "-selected" : ""),
                                    children: isPrepaid ? "Next" : "Submit and cancel order"
                                })
                            })
                        })
                    ]
                }),
                showNextModal && isPrepaid && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cancel-modal-static",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cancel-modal-headings",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cancel-modal-main-heading",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cancel-modal-heading-text",
                                            children: "Cancel Order"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: "https://cdn.dotpe.in/longtail/social_media_templates/7612844/DL67whIR.jpeg",
                                            className: "cancel-icon",
                                            alt: "cancel",
                                            onClick: handleClose
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cancel-modal-description",
                                    children: [
                                        "Your order will be cancelled.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Refund will be issued manually by the merchant. For quicker help, contact:",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontWeight: "bold",
                                                fontSize: "1rem"
                                            },
                                            children: storePhone
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cancel-order-div-selected",
                            style: {
                                position: "absolute",
                                bottom: "2rem",
                                width: "100%",
                                left: "20px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "cancel-order-btn-selected",
                                onClick: handleSubmit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cancel-order-btn-txt-selected",
                                    children: "Confirm Cancellation"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_CancelOrderModal = (CancelOrderModal);

;// CONCATENATED MODULE: ./src/containers/OrderStatus/components/MobileCancelBottomModal.js

var MobileCancelBottomModal = function(param) {
    var handleCancelOrder = param.handleCancelOrder, setShowMoreOptions = param.setShowMoreOptions, showMoreOptions = param.showMoreOptions, setIsCancelModalOpen = param.setIsCancelModalOpen;
    var handleClose = function() {
        setShowMoreOptions(false);
    };
    var handleOverlayClick = function(e) {
        if (e.target === e.currentTarget) {
            setShowMoreOptions(false);
            setIsCancelModalOpen(false);
        }
    };
    var handleCancelClick = function() {
        setShowMoreOptions(false);
        handleCancelOrder();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "more-options-bottom-overlay",
        onClick: handleOverlayClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            fullWidth: true,
            className: "more-options-bottom",
            maxWidth: "sm",
            onClose: handleClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cancel-option-mobile",
                onClick: handleCancelClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        loading: "lazy",
                        src: "https://cdn.dotpe.in/longtail/social_media_templates/7612844/DL67whIR.jpeg",
                        className: "cancel-option-icoon-mobile",
                        alt: "cancel",
                        onClick: handleClose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cancel-option-mobile-text",
                        children: "Cancel Order"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_MobileCancelBottomModal = (MobileCancelBottomModal);

// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var actions_cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/isOrderPending.js
var isOrderPending = __webpack_require__(652219);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
;// CONCATENATED MODULE: ./src/utils/getOrderStatusTextPrefixByStoreType.js

function getOrderStatusTextPrefixByStoreType() {
    var storeType = (0,getStoreType/* getStoreType */.K)();
    switch(storeType){
        case 1:
            return "Booking";
        case 2:
            return "Booking";
        case 3:
            return "Request";
        default:
            return "Order";
    }
}

// EXTERNAL MODULE: ./src/utils/orderItemsToBuyAgain.js
var orderItemsToBuyAgain = __webpack_require__(122877);
// EXTERNAL MODULE: ./src/utils/orderGSTStatus.js
var orderGSTStatus = __webpack_require__(314723);
;// CONCATENATED MODULE: ./src/assets/svgExports/DownloadInvoiceIcon.js

var DownloadInvoiceIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.042",
        height: "14.042",
        viewBox: "0 0 14.042 14.042",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Icon_feather-download",
            "data-name": "Icon feather-download",
            transform: "translate(0.75 0.75)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_229432",
                    "data-name": "Path 229432",
                    d: "M17.042,22.5v2.779a1.391,1.391,0,0,1-1.394,1.389H5.894A1.391,1.391,0,0,1,4.5,25.279V22.5",
                    transform: "translate(-4.5 -14.126)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_229433",
                    "data-name": "Path 229433",
                    d: "M10.5,15l4.038,4.27L18.576,15",
                    transform: "translate(-8.267 -10.265)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_229434",
                    "data-name": "Path 229434",
                    d: "M18,16.211V7.5",
                    transform: "translate(-11.729 -7.5)",
                    fill: "none",
                    stroke: "#000",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1.5"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/assets/svgExports/PhoneIcon.js
var PhoneIcon = __webpack_require__(887546);
// EXTERNAL MODULE: ./src/assets/svgExports/WhatsAppIcon.js
var WhatsAppIcon = __webpack_require__(970870);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(452388);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(336623);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/containers/OrderStatus/OrderStatus.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  border: 1px solid #e6e6eb;\n  margin-top: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: ",
        ";\n  margin-left: 15px;\n  margin-right: 15px;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  color: inherit;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var DownloadInvoiceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DownloadInvoiceContainer",
    componentId: "sc-ce1bf67-0"
})(_templateObject(), function(props) {
    return props.roundness || "0px";
});
var DownloadInvoiceText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "DownloadInvoiceText",
    componentId: "sc-ce1bf67-1"
})(_templateObject1());
var DownloadInvoiceAnchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "DownloadInvoiceAnchor",
    componentId: "sc-ce1bf67-2"
})(_templateObject2());

// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(471778);
// EXTERNAL MODULE: ./src/config/index.js
var config = __webpack_require__(477733);
// EXTERNAL MODULE: ./node_modules/react-rating-stars-component/dist/react-stars.js
var react_stars = __webpack_require__(511312);
// EXTERNAL MODULE: ./src/containers/OrderStatus/ReviewOrderItems.module.scss
var ReviewOrderItems_module = __webpack_require__(394421);
var ReviewOrderItems_module_default = /*#__PURE__*/__webpack_require__.n(ReviewOrderItems_module);
// EXTERNAL MODULE: ./src/components/CustomerReviewModal/index.js + 4 modules
var CustomerReviewModal = __webpack_require__(88557);
;// CONCATENATED MODULE: ./src/containers/OrderStatus/ReviewOrderItems.js






var ReviewOrderItem = function(param) {
    var items = param.items, item = param.item, triggerGetOrderByHash = param.triggerGetOrderByHash, orderDetails = param.orderDetails, index = param.index;
    var ref, ref1;
    var loggedInUserReview = Array.isArray(item === null || item === void 0 ? void 0 : (ref = item.store_item_review_rating) === null || ref === void 0 ? void 0 : ref.review_rating) && (item === null || item === void 0 ? void 0 : (ref1 = item.store_item_review_rating) === null || ref1 === void 0 ? void 0 : ref1.review_rating[0]);
    var ref2 = (0,react.useState)(false), openReviewModal = ref2[0], setOpenReviewModal = ref2[1];
    var ref3 = (0,react.useState)(loggedInUserReview ? loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating : 0), rating = ref3[0], setRating = ref3[1];
    (0,react.useEffect)(function() {
        if (loggedInUserReview) setRating(loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating);
    }, [
        loggedInUserReview
    ]);
    var handleReviewModalOpen = function() {
        return setOpenReviewModal(true);
    };
    var handleReviewModalClose = function() {
        triggerGetOrderByHash();
        setOpenReviewModal(false);
        setRating(loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ReviewOrderItems_module_default()).orderItem,
                style: {
                    borderBottom: index !== (items === null || items === void 0 ? void 0 : items.length) - 1 ? "1.5px solid #e2e2e2" : "0px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-start pb16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item === null || item === void 0 ? void 0 : item.thumbnail_url,
                                width: "64px",
                                height: "64px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-column pl12px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mv0 fw5 f14px pb8px",
                                        children: item === null || item === void 0 ? void 0 : item.item_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mv0 fw5 f14px",
                                        children: [
                                            config/* CURRENCY_SYMBOL */.o,
                                            " ",
                                            item === null || item === void 0 ? void 0 : item.discounted_price
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center pt16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mv0 fw5 f14px pb8px",
                                        children: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) ? "Your ratings" : "Rate product"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                        size: 24,
                                        classNames: (ReviewOrderItems_module_default()).gap,
                                        onChange: function(rating) {
                                            setRating(rating);
                                            handleReviewModalOpen();
                                        },
                                        value: rating,
                                        count: 5
                                    }, "stars_".concat(rating))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ReviewOrderItems_module_default()).verticalLine
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (ReviewOrderItems_module_default()).writeReview,
                                onClick: handleReviewModalOpen,
                                children: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) ? "Edit review" : "Write a Review"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerReviewModal/* default */.Z, {
                open: openReviewModal,
                ratingFromProps: rating,
                onClose: handleReviewModalClose,
                product: item,
                loggedInUserReview: loggedInUserReview,
                order_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id,
                onSubmit: triggerGetOrderByHash
            })
        ]
    });
};
var ReviewOrderItems = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, triggerGetOrderByHash = param.triggerGetOrderByHash, orderDetails = param.orderDetails;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
        className: (ReviewOrderItems_module_default()).reviewOrderItemsContainer,
        children: items === null || items === void 0 ? void 0 : items.map(function(item, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewOrderItem, {
                index: idx,
                item: item,
                items: items,
                triggerGetOrderByHash: triggerGetOrderByHash,
                orderDetails: orderDetails
            }, idx);
        })
    });
};
/* harmony default export */ var OrderStatus_ReviewOrderItems = (ReviewOrderItems);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/utils/getTotalCartAmounts.js
var getTotalCartAmounts = __webpack_require__(668246);
;// CONCATENATED MODULE: ./src/utils/getDeliveryTimeText.js

/**
 *
 * @param {string} deliveryFrom
 * @param {string} deliveryTo
 * @param {string} customeTimeText
 * @param {string} orderUpdateAt
 * @return {object}
 */ var getDeliveryTimeText = function(deliveryFrom, deliveryTo, customeTimeText, orderUpdateAt, deliveryPartnerStatus) {
    var deliveryTimeData = {
        text: "",
        isInfoRequired: false
    };
    // If Custom delivery time text available
    if (customeTimeText) {
        deliveryTimeData.text = "Estimated delivery: ".concat(customeTimeText, ".");
        deliveryTimeData.isInfoRequired = true;
    } else {
        if (deliveryPartnerStatus > 0) {
            var currentTime = moment_default()(moment_default()().format("YYYY-MM-DD HH:mm:ss"));
            deliveryFrom = moment_default()(deliveryFrom);
            deliveryTo = moment_default()(deliveryTo);
            orderUpdateAt = moment_default()(orderUpdateAt);
            var gapBetweenDeliveryTime = moment_default().duration(deliveryTo.diff(deliveryFrom));
            var differenceInHours = gapBetweenDeliveryTime.asHours();
            // if difference is more than or equal to 24hrs
            if (differenceInHours >= 24) {
                if (currentTime.valueOf() > deliveryTo.valueOf()) {
                    deliveryTimeData.text = "Estimated Delivery: ".concat(moment_default()(deliveryFrom).format("DD-MM-YYYY"), " to ").concat(moment_default()(deliveryTo).format("DD-MM-YYYY"), ".");
                    deliveryTimeData.isInfoRequired = true;
                } else {
                    deliveryTimeData.text = "Your order will be delivered between ".concat(moment_default()(deliveryFrom).format("DD-MM-YYYY"), " to ").concat(moment_default()(deliveryTo).format("DD-MM-YYYY"), ".");
                    deliveryTimeData.isInfoRequired = false;
                }
            } else if (differenceInHours > 0 && differenceInHours < 24) {
                var timeFrom = moment_default().duration(deliveryFrom.diff(orderUpdateAt));
                var timeTo = moment_default().duration(deliveryTo.diff(orderUpdateAt));
                var isMin = true;
                if (moment_default().duration(deliveryFrom.diff(orderUpdateAt)).asMinutes() > 60) {
                    timeFrom = timeFrom.asHours();
                    timeTo = timeTo.asHours();
                    isMin = false;
                } else {
                    timeFrom = timeFrom.asMinutes();
                    timeTo = timeTo.asMinutes();
                }
                if (currentTime.valueOf() > deliveryTo.valueOf()) {
                    deliveryTimeData.text = "Estimated Delivery: ".concat(Math.ceil(timeFrom), "-").concat(Math.ceil(timeTo), " ").concat(isMin ? "mins" : "hrs", ".");
                    deliveryTimeData.isInfoRequired = true;
                } else {
                    deliveryTimeData.text = "Your order will be delivered in the next ".concat(Math.ceil(timeFrom), "-").concat(Math.ceil(timeTo), " ").concat(isMin ? "minutes" : "hours", ".");
                    deliveryTimeData.isInfoRequired = false;
                }
            }
        } else {
            deliveryTimeData.text = "Tracking details would be available once the order is shipped.";
            deliveryTimeData.isInfoRequired = true;
        }
    }
    return deliveryTimeData;
};

// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/components/ReadMoreReadLess.js
var ReadMoreReadLess = __webpack_require__(719976);
// EXTERNAL MODULE: ./src/utils/purchaseEventTrigger.js
var purchaseEventTrigger = __webpack_require__(827824);
// EXTERNAL MODULE: ./src/components/ItemSchedulingInfo/index.tsx + 2 modules
var ItemSchedulingInfo = __webpack_require__(995350);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
// EXTERNAL MODULE: ./src/utils/getWhatsAppRedirectionUrl.js
var getWhatsAppRedirectionUrl = __webpack_require__(230066);
;// CONCATENATED MODULE: ./src/containers/OrderStatus/index.js
/**
 * Order Status Screen
 */ 











































var AuthModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 493973));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(493973)
            ];
        }
    }
});
/**
 * Helper to transform orderDetails into Meta Pixel Purchase event parameters.
 */ var preparePurchaseDataForConversion = function(orderDetails, storeInfo) {
    var ref, ref1, ref2;
    var currency = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.currency) === null || ref === void 0 ? void 0 : ref.currency_symbol) || "INR";
    var value = 0;
    var numItems = 0;
    var content_ids = [];
    var contents = [];
    orderDetails === null || orderDetails === void 0 ? void 0 : (ref1 = orderDetails.items) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(item) {
        if (item.item_status === 1) {
            var ref;
            var skuId = (ref = item.id || item.item_id) === null || ref === void 0 ? void 0 : ref.toString();
            var itemPrice = item.price || item.display_price || 0;
            var quantity = item.quantity;
            if (skuId && quantity > 0) {
                content_ids.push(skuId);
                contents.push({
                    id: skuId,
                    quantity: quantity,
                    item_price: itemPrice
                });
                numItems += quantity;
            }
        }
    });
    value = (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value) || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.amount) || 0;
    return {
        content_ids: content_ids,
        contents: contents,
        content_type: "product",
        currency: currency,
        value: value,
        num_items: numItems,
        order_id: (orderDetails === null || orderDetails === void 0 ? void 0 : (ref2 = orderDetails.order_id) === null || ref2 === void 0 ? void 0 : ref2.toString()) || ""
    };
};
var OrderStatus = function() {
    var triggerGetOrderByParentId = function triggerGetOrderByParentId() {
        if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.parent_order_id) && orderDetails.parent_order_id !== 0) {
            dispatch((0,order/* fetchOrderDetailByID */.GW)({
                order_id: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.parent_order_id
            }));
        }
    };
    var isExtraCODCHargeFeatureActive = function isExtraCODCHargeFeatureActive() {
        var ref;
        return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.cod_charge_flag) === constants/* COD_CHARGE_TYPE.FREE */.VV.FREE;
    };
    var triggerGetOrderByHash = /** Calls getorderbyhash api if orderHashParams are present*/ function triggerGetOrderByHash(errorCallback) {
        orderHashFromParams && (user === null || user === void 0 ? void 0 : user.isLogin) && dispatch((0,order/* fetchLoggedInOrderByHash */.q$)({
            order_hash: orderHashFromParams,
            phone: userData === null || userData === void 0 ? void 0 : userData.phone,
            storeId: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id
        }, errorCallback));
    };
    var renderDownloadInvoice = function renderDownloadInvoice() {
        var ref;
        return gstInvoice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadInvoiceAnchor, {
            href: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.gst_invoice,
            target: "_blank",
            download: "invoice.pdf",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DownloadInvoiceContainer, {
                roundness: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadInvoiceIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadInvoiceText, {
                        children: "Download Invoice"
                    })
                ]
            })
        }) : null;
    };
    var renderOrderTime = function renderOrderTime() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "order-time star-dust f12px fw4 mt8px",
            children: [
                isB2bTypeOrder ? "Raised" : "Placed",
                " on",
                " ",
                orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.created_at) === null || ref === void 0 ? void 0 : ref.split(" ")[0],
                " at",
                " ",
                moment_default()(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.created_at).format("LT").toLowerCase()
            ]
        });
    };
    var renderThankYouHeaderIcon = function renderThankYouHeaderIcon() {
        var ref, ref1, ref2;
        var orderStatus = (ref = isOrderChildPartialPaymentType() ? orderDetails : parentOrderDetails) === null || ref === void 0 ? void 0 : ref.status;
        var removeWhatsappMessage = [
            constants/* ORDER_STATUS.COMPLETED */.DF.COMPLETED,
            constants/* ORDER_STATUS.REJECTED */.DF.REJECTED,
            constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED, 
        ].includes(orderStatus);
        var whatsappDefaultMessage = !removeWhatsappMessage ? "Hi%2C+is+my+order+ready%3F" : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                deviceWidth/* deviceWidth */.o < constants/* MAX_MOBILE_WIDTH */.Cf && storePhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "tel:".concat(storePhone),
                    style: {
                        marginRight: 10,
                        padding: "8px 10px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon/* PhoneIcon */.q, {
                        color: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: (0,getWhatsAppRedirectionUrl/* getWhatAppRedirectionUrl */.gi)(whatsappDefaultMessage),
                    target: "_blank",
                    style: {
                        padding: "1px 5px"
                    },
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsAppIcon/* WhatsAppIcon */.y, {})
                })
            ]
        });
    };
    var thankYouHeader = function thankYouHeader() {
        return isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "header-mobile",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    deviceWidth/* deviceWidth */.o < constants/* MAX_MOBILE_WIDTH */.Cf && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "header__top fixed w-100 top-0 bg-white z-2 shadow-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/1cy3Zqf6.webp",
                                onClick: function() {
                                    var ref;
                                    return router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                                }
                            }),
                            (0,getCustomCtaText/* default */.Z)("bill_order_id"),
                            " ",
                            orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                        className: "header--bottom-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "header__bottom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "header__bottom--thank",
                                    children: [
                                        "Thank you for",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " your",
                                        " ",
                                        isB2bTypeOrder ? "request" : (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE ? "Booking" : "Order",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/hhdn1Ncs.webp"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "header__bottom--actions",
                                    children: renderThankYouHeaderIcon()
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    var renderB2bRfqDetails = function renderB2bRfqDetails() {
        var rfqDetailsObj = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_rfq_details;
        var rfqDetailsObjKeys = Object.keys(rfqDetailsObj);
        var filteredRfqDetailsObjKeys = rfqDetailsObjKeys.filter(function(key) {
            if (rfqDetailsObj[key]) return key;
        });
        var filteredRfqDetailsObjKeysLength = filteredRfqDetailsObjKeys === null || filteredRfqDetailsObjKeys === void 0 ? void 0 : filteredRfqDetailsObjKeys.length;
        return !!filteredRfqDetailsObjKeysLength && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "18px 14px 4px 14px",
                margin: "0x 18px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    style: {
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#000000"
                    },
                    children: "Your Details"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    style: {
                        width: "100%",
                        boxShadow: "0px 1px 3px #00000027",
                        borderRadius: 8,
                        border: "0.5px solid #e2e2e2",
                        margin: "0x 18px",
                        padding: "18px 14px 4px 14px"
                    },
                    children: filteredRfqDetailsObjKeys.map(function(fieldkey, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_B2bRfqDetailField, {
                            fieldkey: fieldkey,
                            value: rfqDetailsObj[fieldkey],
                            isFirstElement: idx === 0,
                            isLastElement: idx === filteredRfqDetailsObjKeysLength - 1
                        }, idx);
                    })
                })
            ]
        });
    };
    var isParentOrderGstIncluded = function isParentOrderGstIncluded() {
        if ((parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.gst_type) === constants/* ORDER_GST_TYPE.GST_INCLUDED */.PH.GST_INCLUDED) return true;
        return false;
    };
    var isParentOrderGstExcluded = function isParentOrderGstExcluded() {
        if ((parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.gst_type) === constants/* ORDER_GST_TYPE.GST_EXCLUDED */.PH.GST_EXCLUDED) return true;
        return false;
    };
    var renderDownloadInvoiceForParentOrder = function renderDownloadInvoiceForParentOrder() {
        var ref, ref1;
        if ((parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : (ref = parentOrderDetails.part_payment_info) === null || ref === void 0 ? void 0 : ref.order_completion_status) !== 3) {
            return null;
        }
        var parentGstInvoice = parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.gst_invoice;
        return parentGstInvoice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadInvoiceAnchor, {
            href: parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.gst_invoice,
            target: "_blank",
            download: "invoice.pdf",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DownloadInvoiceContainer, {
                roundness: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : ref1.roundness),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadInvoiceIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadInvoiceText, {
                        children: "Download Invoice"
                    })
                ]
            })
        }) : null;
    };
    var renderOrderDetailComponentWhenChildOrder = function renderOrderDetailComponentWhenChildOrder() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : (ref = parentOrderDetails.delivery_info) === null || ref === void 0 ? void 0 : ref.tracking_url) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "flex pa20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "w-60",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb1 f20px mt0",
                                    children: "Arriving Soon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "f12px lh-copy",
                                    children: "Track your Shipment now"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            className: "flex justify-end items-start w-40",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "pv10px ph24px link",
                                style: {
                                    color: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color : "#ea5151",
                                    border: "1px solid ".concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.theme) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.colors) === null || ref6 === void 0 ? void 0 : ref6.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color : "#ea5151"),
                                    borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref9 = storeInfo.theme) === null || ref9 === void 0 ? void 0 : ref9.roundness)
                                },
                                href: parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : (ref10 = parentOrderDetails.delivery_info) === null || ref10 === void 0 ? void 0 : ref10.tracking_url,
                                rel: "noreferrer",
                                target: "_blank",
                                children: "Track"
                            })
                        })
                    ]
                }),
                isThisCfeSideParentOrder() ? _renderOrderStatusForParentOrder() : _renderParentOrderStatusforAppSideOrders(),
                (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.part_payment_info) && (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : (ref11 = parentOrderDetails.part_payment_info) === null || ref11 === void 0 ? void 0 : ref11.order_completion_status) !== 3 ? null : !(0,isOrderPending/* isOrderPending */.m)(parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.display_status) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked && (user === null || user === void 0 ? void 0 : user.isLogin) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between pv16px ph16px pointer",
                    onClick: function() {
                        var ref;
                        return (ref = document.getElementById("review-section")) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                            behavior: "smooth",
                            block: "end",
                            inline: "nearest"
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mv0 fw5 f14px",
                            children: "Rate the products"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "dropdown button",
                            src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                            width: "10px"
                        })
                    ]
                }) : null,
                (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "bb b--dashed b--black-20 pa3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "f14px ma0 mt2",
                            children: "Booked Successfully"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "f12px ma0 mt1 mb4",
                            style: {
                                color: "#777777"
                            },
                            children: "We have received your booking"
                        })
                    ]
                }),
                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) === 0 && (0,isOrderPending/* isOrderPending */.m)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "bb b--dashed b--black-20 pa3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            children: [
                                isExtraCODCHargeFeatureActive() && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "pv3 f5 fw6 white bn w-100",
                                    style: {
                                        backgroundColor: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref12 = storeInfo.theme) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.colors) === null || ref13 === void 0 ? void 0 : ref13.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref14 = storeInfo.theme) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.colors) === null || ref15 === void 0 ? void 0 : ref15.primary_color : "#ea5151",
                                        borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref16 = storeInfo.theme) === null || ref16 === void 0 ? void 0 : ref16.roundness)
                                    },
                                    onClick: onPayNowBtnClick,
                                    children: "Pay Now"
                                }),
                                isPaymentTypeIsCOD() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mb0 mt2 tc f12px fw6",
                                    style: {
                                        color: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref17 = storeInfo.theme) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.colors) === null || ref18 === void 0 ? void 0 : ref18.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref19 = storeInfo.theme) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.colors) === null || ref20 === void 0 ? void 0 : ref20.primary_color : "#ea5151"
                                    },
                                    children: [
                                        "Pay ₹",
                                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount,
                                        " to delivery person"
                                    ]
                                })
                            ]
                        }),
                        isOrderInInitialisedState() && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "f7 fw5 black-50",
                            children: (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE ? "You can make a payment once you avail the service." : (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_type) === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP ? "You can make payment once order is ready for pickup." : "You can make payment once order is Verified Successfully."
                        })
                    ]
                }),
                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.REJECTED */.DF.REJECTED && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED && renderDownloadInvoiceForParentOrder(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bill-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bill-wrapper__orderDetails flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "fw6 f16px flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "flex justify-center",
                                    children: [
                                        (0,getCustomCtaText/* default */.Z)("bill_order_id"),
                                        " ",
                                        parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_id
                                    ]
                                }),
                                renderOrderTime()
                            ]
                        })
                    })
                }),
                _renderBillForChildOrder(),
                !!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref21 = storeInfo.services) === null || ref21 === void 0 ? void 0 : ref21.partial_payment_flag) && parentOrderDetails.part_payment_info && _renderPartialPaymentDetail(parentOrderDetails),
                (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.part_payment_info) && (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : (ref22 = parentOrderDetails.part_payment_info) === null || ref22 === void 0 ? void 0 : ref22.order_completion_status) !== 3 ? null : !(0,isOrderPending/* isOrderPending */.m)(parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.display_status) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked && (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) !== constants/* ORDER_STATUS.REJECTED */.DF.REJECTED && (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) !== constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED && (user === null || user === void 0 ? void 0 : user.isLogin) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "review-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderStatus_ReviewOrderItems, {
                        triggerGetOrderByHash: triggerGetOrderByHash,
                        items: parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.items,
                        orderDetails: parentOrderDetails
                    })
                }) : null
            ]
        });
    };
    var isOrderChildPartialPaymentType = /** @return {boolean}  Returns a boolean depending on whether the order status page is for a normal order or a child order sent via bill generated  */ function isOrderChildPartialPaymentType() {
        return (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.parent_order_id) !== 0 && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.parent_order_hash) !== "" && parentOrderDetails && (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_id) === (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.parent_order_id);
    };
    var ref, ref1, ref2;
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var orderHashFromParams = router.query.hash;
    /** Local state */ var ref3 = (0,react.useState)({
        showOrderInstructionModal: false,
        deliveryTracking: {
            text: "",
            isInfoRequired: true
        },
        pageTheme: null,
        isStatusBlockVisible: false
    }), state = ref3[0], setState = ref3[1];
    var ref4 = (0,react.useState)(false), showAuthModal = ref4[0], setShowAuthModal = ref4[1];
    var ref5 = (0,react.useState)(false), showMoreOptions = ref5[0], setShowMoreOptions = ref5[1];
    var ref6 = (0,react.useState)(false), showCancellationModal = ref6[0], setShowCancellationModal = ref6[1];
    var ref7 = (0,react.useState)(false), isCancelModalOpen = ref7[0], setIsCancelModalOpen = ref7[1];
    /** Store Selectors */ var cart = (0,es/* useSelector */.v9)(function(state) {
        return state.cartReducer;
    });
    var ref8 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return {
            orderDetails: (ref = state.orderReducer) === null || ref === void 0 ? void 0 : ref.orderDetails,
            gstInvoice: (ref1 = state.orderReducer) === null || ref1 === void 0 ? void 0 : ref1.gstInvoice,
            user: state.userReducer,
            reviewSettings: state.catalogReducer.reviewSettings,
            parentOrderDetails: (ref2 = state.orderReducer) === null || ref2 === void 0 ? void 0 : ref2.parentOrderDetails
        };
    }), orderDetails = ref8.orderDetails, gstInvoice = ref8.gstInvoice, user = ref8.user, reviewSettings = ref8.reviewSettings, parentOrderDetails = ref8.parentOrderDetails;
    var loader = (0,es/* useSelector */.v9)(function(state) {
        return state.commonReducer;
    }).loader;
    var userData = (0,es/* useSelector */.v9)(function(state) {
        return state.userReducer.data;
    });
    var services = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    }).services;
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var crrFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().crrFeatureStatus;
    var isCRRFeatureUnlocked = !(crrFeatureStatus === null || crrFeatureStatus === void 0 ? void 0 : crrFeatureStatus.isLocked);
    var isB2bTypeOrder = (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.B2B */.Jm.B2B;
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    (0,react.useEffect)(function() {
        if ((0,purchaseEventTrigger/* shouldTrrigerPurchaseEvent */.yu)() && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) === orderHashFromParams) {
            (0,purchaseEventTrigger/* unsetPurchaseTrigger */._W)();
            var data = {
                event: "purchase",
                transaction_id: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id) || "",
                value: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value) || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.amount),
                tax: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.total_gst_paid,
                shipping: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.delivery_charge,
                currency: "INR"
            };
            (0,purchaseEventTrigger/* pushPurchaseEventToDataLayer */.gW)(data, orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id);
            // --- Meta Pixel Purchase Implementation ---
            var pixelData = preparePurchaseDataForConversion(orderDetails, storeInfo);
            if (window.fbq && pixelData.contents.length > 0) {
                console.log("===Meta Pixel - Purchase Fired:", pixelData);
                window.fbq("track", "Purchase", pixelData);
            }
        }
        return function() {
            return (0,purchaseEventTrigger/* removeExistingPurchaseEventFromDataLayer */.rA)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id);
        };
    }, [
        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id
    ]);
    (0,react.useEffect)(function() {
        localStorage.removeItem("state");
        localStorage.removeItem("deliveryType");
        dispatch((0,common/* setLoaderState */.l8)(true));
        dispatch((0,actions_cart/* emptyCart */.UY)());
        triggerGetOrderByHash();
        triggerGetOrderByParentId();
        if (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) {
            dispatch((0,catalog/* getCustomerReviewSettings */.vV)(storeInfo.store_id));
        }
        // dispatch(fetchStoreInfoBySubDomain(storeInfo?.domain));
        var intervalTimer = setInterval(function() {
            triggerGetOrderByHash(stopInterval);
        }, 3000);
        if (!(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token"))) {
            localStorage.removeItem("auth_token");
            setShowAuthModal(true);
        }
        var stopInterval = function() {
            clearInterval(intervalTimer);
        };
        return stopInterval;
    }, []);
    (0,react.useEffect)(function() {
        triggerGetOrderByHash();
    }, [
        user === null || user === void 0 ? void 0 : user.isLogin
    ]);
    (0,react.useEffect)(function() {
        if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) === orderHashFromParams) {
            triggerGetOrderByParentId();
            if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.created_at) !== orderDetails.updated_at) {
                var ref, ref1, ref2, ref3;
                var deliveryTracking = getDeliveryTimeText(orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.delivery_info) === null || ref === void 0 ? void 0 : ref.delivery_from, orderDetails === null || orderDetails === void 0 ? void 0 : (ref1 = orderDetails.delivery_info) === null || ref1 === void 0 ? void 0 : ref1.delivery_to, orderDetails === null || orderDetails === void 0 ? void 0 : (ref2 = orderDetails.delivery_info) === null || ref2 === void 0 ? void 0 : ref2.delivery_time, orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.updated_at, orderDetails === null || orderDetails === void 0 ? void 0 : (ref3 = orderDetails.delivery_info) === null || ref3 === void 0 ? void 0 : ref3.assigned_to);
                setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        deliveryTracking: deliveryTracking
                    });
                });
            }
        }
    }, [
        orderDetails
    ]);
    (0,react.useEffect)(function() {
        if ((0,purchaseEventTrigger/* shouldTrrigerPurchaseEvent */.yu)() && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash) === orderHashFromParams) {
            (0,purchaseEventTrigger/* unsetPurchaseTrigger */._W)();
            var data = {
                event: "purchase",
                transaction_id: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id) || "",
                value: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.buyer_pay_value) || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.amount),
                tax: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.total_gst_paid,
                shipping: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.delivery_charge,
                currency: "INR"
            };
            (0,purchaseEventTrigger/* pushPurchaseEventToDataLayer */.gW)(data, orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id);
        }
        return function() {
            return (0,purchaseEventTrigger/* removeExistingPurchaseEventFromDataLayer */.rA)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id);
        };
    }, [
        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id
    ]);
    /** fetching GST invoice  */ (0,react.useEffect)(function() {
        dispatch((0,order/* getGstInvoice */.Z4)());
    }, [
        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag,
        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status
    ]);
    /**
   * Buy Again handle
   * @param {Array} items
   */ var handleNavigateReorder = function() {
        var ref;
        if (!isThisCfeSideOrder()) {
            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo.store_info.domain));
            return;
        }
        var items = orderDetails.items ? (0,_to_consumable_array/* default */.Z)(orderDetails.items) : [];
        items = (0,orderItemsToBuyAgain/* orderItemsToBuyAgain */.C)(items);
        var amount_values = (0,getTotalCartAmounts/* getTotalCartAmounts */.a)(items);
        var payload = (0,_object_spread/* default */.Z)({
            items: (0,_to_consumable_array/* default */.Z)(cart.items).concat((0,_to_consumable_array/* default */.Z)(items)),
            store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
            merchant_id: 1,
            order_type: constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
            phone: userData === null || userData === void 0 ? void 0 : userData.phone,
            status: 1,
            status_message: "New",
            deliver_to: "",
            address1: "",
            address2: "",
            latitude: 0,
            longitude: 0
        }, amount_values);
        dispatch((0,actions_cart/* saveCart */.FP)(payload));
        router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    /** Pay Now button handle */ var onPayNowBtnClick = function() {
        // for desktop user
        if (deviceWidth/* deviceWidth */.o > 990) {
            dispatch((0,common/* setPaymentModalVisiblity */.Tc)(true));
        } else {
            var ref;
            router.push((0,routes.getRoute)(routes.PATH.payment(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash), storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        }
    };
    var isThisCfeSideOrder = function() {
        return [
            0,
            1,
            2
        ].includes(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type);
    };
    var toggleStatusBlock = function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isStatusBlockVisible: !state.isStatusBlockVisible
            });
        });
    };
    /**
   * If order is of partial payment type, then if the order is complete - it should return true, else false.
   * If order is of normal type, i.e non partial payment type, then this function will have no impact and returns true.
   * @return {boolean}
   */ var isOrderPartialPaymentTypeAndComplete = function() {
        if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.part_payment_info) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.partial_payment_type) > 0) {
            var ref;
            return (orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.part_payment_info) === null || ref === void 0 ? void 0 : ref.order_completion_status) === 3;
        }
        return true;
    };
    /**
   * Helper function for calculation of
   * item amount total
   * @return {number}
   */ var getItemTotal = function() {
        var ref;
        return orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.items) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, curr) {
            if (curr.item_status === 1) acc = acc + curr.amount;
            return acc;
        }, 0);
    };
    /**
   * return the order process status text
   * @return {string}
   */ var getOrderStatusProcessText = function() {
        var processingText = {
            title: "",
            subtitle: ""
        };
        if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.CONFIRMED_COD */.DF.CONFIRMED_COD) {
            processingText.title = isB2bTypeOrder ? "Request Raised" : "Order Placed";
            processingText.subtitle = isB2bTypeOrder ? "We have received your request." : "We have received your order.";
        } else if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.digital_receipt) === "") {
            processingText.title = isB2bTypeOrder ? "Request Seen" : "Order Seen";
            processingText.subtitle = "We will get your order ready for pickup soon.";
        } else {
            if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) == constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP) {
                processingText.title = "Your Order is Ready for Pickup";
            } else processingText.title = isB2bTypeOrder ? "Your quotation has been Verified successfully" : "Your Order is Verified Successfully";
        }
        return processingText;
    };
    var getOrderStatusProcessTextServiceBased = function() {
        var processingText = {
            title: "",
            subtitle: ""
        };
        if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED) {
            processingText.title = "Booking Placed";
            processingText.subtitle = "We have received your booking.";
        } else {
            processingText.title = "Booking Seen";
            processingText.subtitle = "We will get your booking ready soon.";
        }
        return processingText;
    };
    var toggleAuthModal = function() {
        if (!(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token"))) return;
        if ((user === null || user === void 0 ? void 0 : user.isLogin) && showAuthModal) {
            setShowAuthModal(false);
        } else if ((user === null || user === void 0 ? void 0 : user.isLogin) && !showAuthModal) {
            setShowAuthModal(false);
        } else {
            setShowAuthModal(function(prevState) {
                return !prevState;
            });
        }
    };
    /**
   * Return the boolean for COD type payments
   * @return {boolean}
   */ var isPaymentTypeIsCOD = function() {
        var ref, ref1;
        return (orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.delivery_info) === null || ref === void 0 ? void 0 : ref.assigned_to) == 1 && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.payment_status) == 1 || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.cod_charge_flag) > constants/* COD_CHARGE_TYPE.FREE */.VV.FREE && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) === 0;
    };
    var isPrepaidOrderCancelledOrRejected = function() {
        return ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.REJECTED */.DF.REJECTED || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.payment_status) == 9;
    };
    /**
   * Return JSX for
   * Order Status type Complete
   * @return {JSX}
   */ var _renderOrderStatusComplete = function() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.COMPLETED */.DF.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6 flex justify-start items-center",
                children: [
                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/q1kVDpRv.webp",
                        className: "img h2 mr2"
                    }),
                    "Your Order is Complete.",
                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/q1kVDpRv.webp",
                        className: "img h2 mr2"
                    })
                ]
            }) : (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.REJECTED */.DF.REJECTED && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) === constants/* DISPLAY_STATUS.REJECTED */.Uq.REJECTED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/eJFFlBiC.webp",
                        className: "mb2 img h2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Your order has been rejected",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status_message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "f7 fw6 black-40",
                        children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status_message
                    }),
                    isPrepaidOrderCancelledOrRejected() && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "f7 fw6 black-40",
                        children: "The merchant has rejected your order. Please contact them at ".concat(storePhone, " for refund or further assistance.")
                    })
                ]
            }) : (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/eJFFlBiC.webp",
                        className: "mb2 img h2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    getOrderStatusTextPrefixByStoreType(),
                    " Cancelled",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status_message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "f7 fw6 black-40",
                        children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status_message
                    }),
                    isPrepaidOrderCancelledOrRejected() && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "f7 fw6 black-40",
                        children: "Please contact the merchant at ".concat(storePhone, " for assistance. The refund will be processed manually.")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/KIE24hYi.webp",
                        className: "mb2 img h2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (ref = getOrderStatusProcessText()) === null || ref === void 0 ? void 0 : ref.title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && state.deliveryTracking.text && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "f7 fw6 black-40",
                        children: state.deliveryTracking.text
                    })
                ]
            })
        });
    };
    var _renderOrderStatusCompleteService = function() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.COMPLETED */.DF.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6 flex justify-start items-center",
                children: [
                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/q1kVDpRv.webp",
                        className: "img h2 mr2"
                    }),
                    "Your Booking is Complete.",
                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/q1kVDpRv.webp",
                        className: "img h2 mr2"
                    })
                ]
            }) : (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.REJECTED */.DF.REJECTED && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) === constants/* DISPLAY_STATUS.REJECTED */.Uq.REJECTED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/eJFFlBiC.webp",
                        className: "mb2 img h2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Your Booking has been rejected",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status_message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "f7 fw6 black-40",
                        children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status_message
                    })
                ]
            }) : (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/eJFFlBiC.webp",
                        className: "mb2 img h2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Booking Cancelled",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status_message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "f7 fw6 black-40",
                        children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status_message
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/KIE24hYi.webp",
                        className: "mb2 img h2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (ref = getOrderStatusProcessTextServiceBased()) === null || ref === void 0 ? void 0 : ref.title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            })
        });
    };
    /**
   * Return JSX for
   * Order Status Processing
   * @return {JSX}
   */ var _renderOrderStatusProccessingService = function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "order-status__processing",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "order-status__processing--top",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "title-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "f5 fw6",
                                    children: (ref = getOrderStatusProcessTextServiceBased()) === null || ref === void 0 ? void 0 : ref.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "f7 fw5 gray",
                                    children: (ref1 = getOrderStatusProcessTextServiceBased()) === null || ref1 === void 0 ? void 0 : ref1.subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            className: "status",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "f7 fw6 pv2 mr2 flex justify-start items-center pointer",
                                onClick: toggleStatusBlock,
                                children: [
                                    "Check Status",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "dropdown button",
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                        className: "h2 img ml2 ".concat(state.isStatusBlockVisible ? "arrow-up" : "arrow-down")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                state.isStatusBlockVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "order-status__processing--bottom pt4 pb3 ph1 flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-column items-center f7 fw6 mw4 h-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/7pzKCEUO.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Booking Placed"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-column justify-center items-center tc f7 fw6 mw4 h-100",
                            children: [
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/7pzKCEUO.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/quONXE2Z.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Booking Seen",
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "o-30 f8 mt2",
                                    children: "Booking is yet to be seen."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-column items-center f7 fw6 m4 h-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/quONXE2Z.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Booking Processed"
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var _renderOrderStatusProccessing = function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "order-status__processing",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "order-status__processing--top",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "title-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "f5 fw6",
                                    children: (ref = getOrderStatusProcessText()) === null || ref === void 0 ? void 0 : ref.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "f7 fw5 gray",
                                    children: (ref1 = getOrderStatusProcessText()) === null || ref1 === void 0 ? void 0 : ref1.subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            className: "status",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "f7 fw6 pv2 mr2 flex justify-start items-center pointer",
                                onClick: toggleStatusBlock,
                                children: [
                                    "Check Status",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "dropdown button",
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                        className: "h2 img ml2 ".concat(state.isStatusBlockVisible ? "arrow-up" : "arrow-down")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                state.isStatusBlockVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "order-status__processing--bottom pt4 pb3 ph1 flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-column items-center f7 fw6 mw4 h-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/7pzKCEUO.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                isB2bTypeOrder ? "Request Raised" : "Order Placed"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-column justify-center items-center tc f7 fw6 mw4 h-100",
                            children: [
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/7pzKCEUO.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/quONXE2Z.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                isB2bTypeOrder ? "Request Seen" : "Order Seen",
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.CONFIRMED_COD */.DF.CONFIRMED_COD && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "o-30 f8 mt2",
                                    children: "".concat(isB2bTypeOrder ? "Request" : "Order", " is yet to be seen.")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-column items-center f7 fw6 m4 h-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/quONXE2Z.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Ready for ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Pickup",
                                        " "
                                    ]
                                }) : isB2bTypeOrder ? "Request Closed" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Out for ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " Delivery"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    /**
   * Return JSX for
   * Order Status Block
   * @return {JSX}
   */ var _renderOrderStatus = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "order-status",
            children: !((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.CONFIRMED_COD */.DF.CONFIRMED_COD) ? _renderOrderStatusComplete() : _renderOrderStatusProccessing()
        });
    };
    var _renderOrderStatusService = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "order-status",
            children: !((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.CONFIRMED_COD */.DF.CONFIRMED_COD) ? _renderOrderStatusCompleteService() : _renderOrderStatusProccessingService()
        });
    };
    var _renderOrderStatusforAppSideOrders = function() {
        return !(0,isOrderPending/* isOrderPending */.m)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) !== constants/* DISPLAY_STATUS.REJECTED */.Uq.REJECTED ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "order-status",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6 mb2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/7pzKCEUO.webp",
                        className: "mb2 img h3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Your have paid ₹",
                    orderDetails.pay_amount
                ]
            })
        }) : null;
    };
    /**
   * Return JSX for Bill
   * @return {JSX}
   */ var _renderBill = function() {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "order-bill",
            style: {
                minHeight: isB2bTypeOrder ? "60px" : "100px",
                padding: isB2bTypeOrder ? "18px 14px 4px 14px" : "18px 14px 20px 14px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "items-details-container tw-flex tw-flex-col tw-gap-4 ",
                    children: orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.items) === null || ref === void 0 ? void 0 : ref.map(function(item, ind) {
                        var ref, ref1;
                        var savingAmt = (item === null || item === void 0 ? void 0 : item.actual_amount) * (item === null || item === void 0 ? void 0 : item.quantity) - item.amount;
                        var personalizationData = item === null || item === void 0 ? void 0 : (ref = item.personalization_info) === null || ref === void 0 ? void 0 : ref.personalizations;
                        return item.item_status === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col ".concat(ind !== (orderDetails === null || orderDetails === void 0 ? void 0 : (ref1 = orderDetails.items) === null || ref1 === void 0 ? void 0 : ref1.length) - 1 ? "tw-border-b-[0.3000000119px] tw-border-dashed tw-border-[#9d9fa9]" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: "bill-table bill-items-margin",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fw4 item-name-container responsive-major-text",
                                            style: {
                                                maxWidth: isB2bTypeOrder ? "100%" : "50%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-column tw-text-[0.75rem] tw-font-semibold md:tw-text-[0.875rem] ",
                                                    children: [
                                                        item === null || item === void 0 ? void 0 : item.item_name,
                                                        " X ",
                                                        item === null || item === void 0 ? void 0 : item.quantity,
                                                        (item === null || item === void 0 ? void 0 : item.variant_name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "mt4px star-dust responsive-minor-text",
                                                            children: [
                                                                " ",
                                                                item === null || item === void 0 ? void 0 : item.variant_name,
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                item.additional_remark ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-column f12px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt3 mb0 fw4 tile-gray-color",
                                                            children: "Additional Remarks:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "mt1 fw4 mb0",
                                                            children: [
                                                                '"',
                                                                item.additional_remark,
                                                                '"'
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        !isB2bTypeOrder ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-column fw4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "flex justify-end",
                                                    children: (item === null || item === void 0 ? void 0 : item.item_type) !== "list" ? "₹ ".concat(item === null || item === void 0 ? void 0 : item.discounted_price) : "-"
                                                }),
                                                (item === null || item === void 0 ? void 0 : item.item_type) !== "list" && savingAmt > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "fw4 mt4px color-green responsive-minor-text",
                                                    children: [
                                                        config/* CURRENCY_SYMBOL */.o,
                                                        "\xa0",
                                                        savingAmt === null || savingAmt === void 0 ? void 0 : savingAmt.toFixed(2),
                                                        " Saved"
                                                    ]
                                                })
                                            ]
                                        }) : null
                                    ]
                                }, "order-item-".concat(ind)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSchedulingInfo/* default */.Z, {
                                    schedulingInfo: item === null || item === void 0 ? void 0 : item.schedule_info,
                                    customClasses: "!tw-pt-[10px] !tw-pb-[24px]",
                                    headingClasses: "!tw-font-medium",
                                    paraClasses: "!tw-text-[14px]/[17px]"
                                }),
                                !!(personalizationData === null || personalizationData === void 0 ? void 0 : personalizationData.length) && (personalizationData === null || personalizationData === void 0 ? void 0 : personalizationData.map(function(data, idx) {
                                    var ref, ref1, ref2, ref3;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-mb-[1rem] tw-flex tw-flex-col tw-gap-[0.75rem]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "tw-flex tw-gap-[0.5rem]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "tw-text-[0.75rem] tw-font-medium tw-text-[#242121] md:tw-text-[0.875rem]",
                                                        children: [
                                                            " ",
                                                            "Personalisation details",
                                                            " "
                                                        ]
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "tw-text-[0.875rem] tw-font-normal tw-text-[#242121]",
                                                        children: [
                                                            "x ",
                                                            data === null || data === void 0 ? void 0 : data.quantity
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-flex tw-flex-col tw-gap-3",
                                                children: [
                                                    !!(data === null || data === void 0 ? void 0 : (ref = data.images) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-flex tw-flex-wrap tw-gap-[0.625rem]",
                                                        children: data === null || data === void 0 ? void 0 : (ref1 = data.images) === null || ref1 === void 0 ? void 0 : ref1.map(function(imgUrl, idx) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: imgUrl,
                                                                alt: "image",
                                                                width: "40px",
                                                                height: "40px",
                                                                className: "tw-rounded tw-border tw-border-solid tw-border-[#0000001A]"
                                                            }, idx);
                                                        })
                                                    }),
                                                    !!(data === null || data === void 0 ? void 0 : (ref2 = data.texts) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-flex tw-flex-col tw-gap-2",
                                                        children: data === null || data === void 0 ? void 0 : (ref3 = data.texts) === null || ref3 === void 0 ? void 0 : ref3.map(function(text, idx) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreReadLess/* default */.Z, {
                                                                text: text,
                                                                color: "#6B6B6B"
                                                            }, idx);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, idx);
                                }))
                            ]
                        }) : null;
                    })
                }),
                !isB2bTypeOrder ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "overall-details-wrapper sonic-silver",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: "bill-table",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fw4 f7",
                                            children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE ? "Total" : "Item Total"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fw4 f7 tr",
                                            children: [
                                                "₹\xa0",
                                                (ref1 = getItemTotal()) === null || ref1 === void 0 ? void 0 : ref1.toFixed(2)
                                            ]
                                        })
                                    ]
                                }),
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && Number(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.delivery_charge) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: "bill-table mt10px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fw4 f7",
                                            children: "Delivery fees"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fw4 f7 tr",
                                            children: [
                                                "₹\xa0",
                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.delivery_charge
                                            ]
                                        })
                                    ]
                                }),
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.cod_charge_flag) > constants/* COD_CHARGE_TYPE.FREE */.VV.FREE || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.cod_charges) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: "bill-table mt10px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fw4 f7",
                                            children: "Extra Charges on COD"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fw4 f7 tr",
                                            children: [
                                                "₹\xa0",
                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.cod_charges
                                            ]
                                        })
                                    ]
                                }),
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charges) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: "bill-table mt10px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fw4 f7",
                                            children: [
                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charge_name.substr(0, 20),
                                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charge_name.length) > 20 && "..."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fw4 f7 tr",
                                            children: [
                                                "₹\xa0",
                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.extra_charges
                                            ]
                                        })
                                    ]
                                }),
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: "bill-table mt10px color-green",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fw4 f7",
                                            children: "Discount"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fw4 f7 tr",
                                            children: [
                                                "- ₹\xa0",
                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.discount
                                            ]
                                        })
                                    ]
                                }),
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.promo_discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: "bill-table mt10px color-green",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fw4 f7",
                                            children: "Promo Discount"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fw4 f7 tr",
                                            children: [
                                                "- ₹\xa0",
                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.promo_discount
                                            ]
                                        })
                                    ]
                                }),
                                (0,orderGSTStatus/* isOrderGstExcluded */.e)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: "bill-table mt10px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fw4 f7",
                                            children: "GST"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "fw4 f7 tr",
                                            children: [
                                                "₹\xa0",
                                                orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.total_gst_paid
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "conclusion",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "fw6 responsive-major-text",
                                            children: [
                                                "Grand Total",
                                                (0,orderGSTStatus/* isOrderGstIncluded */.S)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "incl-gst responsive-minor-text fw4 ml6px",
                                                    children: [
                                                        "(Incl. ₹ ",
                                                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.total_gst_paid,
                                                        " GST)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "fw6 pay-amount responsive-major-text",
                                            children: [
                                                "₹\xa0",
                                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.part_payment_info) ? orderDetails === null || orderDetails === void 0 ? void 0 : (ref3 = orderDetails.part_payment_info) === null || ref3 === void 0 ? void 0 : ref3.total_payable_amount : orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount
                                            ]
                                        })
                                    ]
                                }),
                                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.offer_text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-start items-center f7 fw4 pv1 mr5",
                                    dangerouslySetInnerHTML: {
                                        __html: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.offer_text
                                    }
                                }) : null
                            ]
                        })
                    ]
                }) : null
            ]
        });
    };
    var noOrderDetailsFound = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "tc pt3 f3",
            children: "No order details found!"
        });
    };
    var _renderPartialPaymentDetail = function(orderDetail) {
        var ref, ref1, ref2;
        if ((orderDetail === null || orderDetail === void 0 ? void 0 : (ref = orderDetail.part_payment_info) === null || ref === void 0 ? void 0 : ref.order_completion_status) === 3) return null;
        var partiallyPaidAmount = (ref1 = orderDetail.part_payment_info) === null || ref1 === void 0 ? void 0 : ref1.amount_paid;
        var remainingAmount = (ref2 = orderDetail.part_payment_info) === null || ref2 === void 0 ? void 0 : ref2.due_amount;
        var partialPaymentType = storeInfo.services.partial_payment_flag;
        var partialPaymentShare = storeInfo.services.partial_payment_value;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "partial-payment-receipt",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "icons-display",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "icon one",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/icons/greenTickIcon.svg"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "icon two",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/icons/grayPendingIcon.svg"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "amount-display",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "partial-pay-amount",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "amount-value",
                                    children: [
                                        "₹ ",
                                        partiallyPaidAmount
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "amount-text",
                                    children: [
                                        "(",
                                        partialPaymentShare,
                                        partialPaymentType === 1 ? "%" : "₹",
                                        " of grand total)"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "remaining-pay-amount",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "amount-value",
                                    children: [
                                        "₹ ",
                                        remainingAmount
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "amount-text",
                                    children: "(Remaining Amount)"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    /**
   * return footer segment of page if certain conditions are met
   * conditions are as followed
   * - lodaer is false
   * - store is not closed
   * - order is not pending
   * - order is not rejected
   * @return {JSX} JSX Component
   */ var footerComponent = function() {
        var ref, ref1, ref2, ref3;
        return loader === false && (services === null || services === void 0 ? void 0 : services.store_flag) !== 0 && !(0,isOrderPending/* isOrderPending */.m)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) !== constants/* DISPLAY_STATUS.REJECTED */.Uq.REJECTED && !showCancellationModal && !isCancelModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
            className: "ph3 pv2 bg-white flex flex-column justify-center items-center shadow-1 z-2",
            children: [
                !isThisCfeSideOrder() && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "tc",
                    children: "Looking for something else"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "w-100 pv3 white bold f4 bn",
                    style: {
                        backgroundColor: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#ea5151"
                    },
                    onClick: handleNavigateReorder,
                    children: isThisCfeSideOrder() ? "Buy Again" : "Go to Online Store"
                })
            ]
        });
    };
    var handleMoreOptions = function() {
        setShowMoreOptions(!showMoreOptions);
        setIsCancelModalOpen(!isCancelModalOpen);
    };
    var isOrderInInitialisedState = function() {
        var ref;
        if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.part_payment_info) && ((ref = orderDetails.part_payment_info) === null || ref === void 0 ? void 0 : ref.child_orders.length) > 0) {
            var childOrder = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.part_payment_info.child_orders[0];
            return [
                constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED,
                constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN,
                constants/* ORDER_STATUS.CONFIRMED_COD */.DF.CONFIRMED_COD,
                constants/* ORDER_STATUS.PART_ORDER_RECIEVED */.DF.PART_ORDER_RECIEVED, 
            ].includes(childOrder === null || childOrder === void 0 ? void 0 : childOrder.status);
        }
        return [
            constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED,
            constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN,
            constants/* ORDER_STATUS.CONFIRMED_COD */.DF.CONFIRMED_COD,
            constants/* ORDER_STATUS.PART_ORDER_RECIEVED */.DF.PART_ORDER_RECIEVED, 
        ].includes(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status);
    };
    var handleCancelOrder = function() {
        setShowCancellationModal(!showCancellationModal);
    };
    var getCODPaymentMessage = function() {
        if (!isB2bTypeOrder || isB2bTypeOrder && !!(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount)) {
            var ref, ref1, ref2, ref3;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb0 mt2 tc f12px fw6",
                style: {
                    color: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#ea5151"
                },
                children: "Pay ₹".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.pay_amount, " to delivery person")
            });
        }
    };
    var orderDetailComponent = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (orderDetails === null || orderDetails === void 0 ? void 0 : (ref = orderDetails.delivery_info) === null || ref === void 0 ? void 0 : ref.tracking_url) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "flex pa20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "w-60",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb1 f20px mt0",
                                    children: "Arriving Soon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "f12px lh-copy",
                                    children: "Track your Shipment now"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            className: "flex justify-end items-start w-40",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "pv10px ph24px link",
                                style: {
                                    color: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color : "#ea5151",
                                    border: "1px solid ".concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.theme) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.colors) === null || ref6 === void 0 ? void 0 : ref6.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color : "#ea5151"),
                                    borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref9 = storeInfo.theme) === null || ref9 === void 0 ? void 0 : ref9.roundness)
                                },
                                href: orderDetails === null || orderDetails === void 0 ? void 0 : (ref10 = orderDetails.delivery_info) === null || ref10 === void 0 ? void 0 : ref10.tracking_url,
                                rel: "noreferrer",
                                target: "_blank",
                                children: "Track"
                            })
                        })
                    ]
                }),
                isThisCfeSideOrder() ? _renderOrderStatus() : _renderOrderStatusforAppSideOrders(),
                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.part_payment_info) && (orderDetails === null || orderDetails === void 0 ? void 0 : (ref11 = orderDetails.part_payment_info) === null || ref11 === void 0 ? void 0 : ref11.order_completion_status) !== 3 ? null : !(0,isOrderPending/* isOrderPending */.m)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked && (user === null || user === void 0 ? void 0 : user.isLogin) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.REJECTED */.DF.REJECTED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between pv16px ph16px pointer",
                    onClick: function() {
                        var ref;
                        return (ref = document.getElementById("review-section")) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                            behavior: "smooth",
                            block: "end",
                            inline: "nearest"
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mv0 fw5 f14px",
                            children: "Rate the products"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "dropdown button",
                            src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                            width: "10px"
                        })
                    ]
                }) : null,
                !isThisCfeSideOrder() && _renderOrderStatusService(),
                showCancellationModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CancelOrderModal, {
                    showCancellationModal: showCancellationModal,
                    setShowCancellationModal: setShowCancellationModal,
                    setShowMoreOptions: setShowMoreOptions,
                    setIsCancelModalOpen: setIsCancelModalOpen
                }),
                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) === 0 && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.REJECTED */.DF.REJECTED && (0,isOrderPending/* isOrderPending */.m)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "bb b--dashed b--black-20 pa3 pay-now-box",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            children: [
                                isExtraCODCHargeFeatureActive() && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.cod_charges) === 0 && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.prepaid_flag) == constants/* PREPAID_FLAG.POSTPAID */.Z6.POSTPAID && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "pv3 f5 fw6 white bn w-100 ".concat(((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN || isPaymentTypeIsCOD()) && "o-50"),
                                    style: {
                                        backgroundColor: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref12 = storeInfo.theme) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.colors) === null || ref13 === void 0 ? void 0 : ref13.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref14 = storeInfo.theme) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.colors) === null || ref15 === void 0 ? void 0 : ref15.primary_color : "#ea5151",
                                        borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref16 = storeInfo.theme) === null || ref16 === void 0 ? void 0 : ref16.roundness)
                                    },
                                    onClick: onPayNowBtnClick,
                                    disabled: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED || (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN || isPaymentTypeIsCOD(),
                                    children: "Pay Now"
                                }),
                                isPaymentTypeIsCOD() && getCODPaymentMessage()
                            ]
                        }),
                        isExtraCODCHargeFeatureActive() && isOrderInInitialisedState() && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "f7 fw5 black-50",
                            children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE ? "You can make a payment once you avail the service." : (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP ? "You can make payment once order is ready for pickup." : "You can make payment once order is Verified Successfully."
                        })
                    ]
                }),
                isOrderInInitialisedState() && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref17 = storeInfo.services) === null || ref17 === void 0 ? void 0 : ref17.cancel_flag) === 2 && orderDetails.cancellation_deadline !== "" && moment_default()(orderDetails === null || orderDetails === void 0 ? void 0 : (ref18 = orderDetails.cancellation_deadline) === null || ref18 === void 0 ? void 0 : ref18.substring(0, 10)).isSameOrAfter(moment_default()().format("YYYY-MM-DD")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "more-options-box ".concat(showMoreOptions ? "all-more-options" : "single-more-options"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "f7 fw6 pv2 mr2 flex justify-start items-center pointer more-options-heading-box",
                            onClick: handleMoreOptions,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "more-options-heading",
                                    children: "More Options "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "dropdown button",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                    className: " below-arrow ".concat(showMoreOptions && isCancelModalOpen ? "arrow-up" : "arrow-down")
                                })
                            ]
                        }),
                        !checkClientDeviceType/* IS_MOBILE */.q$ && showMoreOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cancel-order pointer",
                            onClick: handleCancelOrder,
                            children: "Cancel Order"
                        }),
                        checkClientDeviceType/* IS_MOBILE */.q$ && showMoreOptions && isCancelModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MobileCancelBottomModal, {
                            handleCancelOrder: handleCancelOrder,
                            setShowMoreOptions: setShowMoreOptions,
                            showMoreOptions: showMoreOptions,
                            setIsCancelModalOpen: setIsCancelModalOpen
                        })
                    ]
                }),
                isOrderPartialPaymentTypeAndComplete() && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.REJECTED */.DF.REJECTED && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED && renderDownloadInvoice(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bill-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bill-wrapper__orderDetails flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "fw6 f16px flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "flex justify-center",
                                    children: [
                                        (0,getCustomCtaText/* default */.Z)("bill_order_id"),
                                        " ",
                                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_id
                                    ]
                                }),
                                renderOrderTime()
                            ]
                        })
                    })
                }),
                _renderBill(),
                !!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref19 = storeInfo.services) === null || ref19 === void 0 ? void 0 : ref19.partial_payment_flag) && orderDetails.part_payment_info && _renderPartialPaymentDetail(orderDetails),
                (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.part_payment_info) && (orderDetails === null || orderDetails === void 0 ? void 0 : (ref20 = orderDetails.part_payment_info) === null || ref20 === void 0 ? void 0 : ref20.order_completion_status) !== 3 ? null : !(0,isOrderPending/* isOrderPending */.m)(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.display_status) && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.REJECTED */.DF.REJECTED && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.CUSTOMER_CANCELLED */.DF.CUSTOMER_CANCELLED && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked && (user === null || user === void 0 ? void 0 : user.isLogin) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "review-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderStatus_ReviewOrderItems, {
                        triggerGetOrderByHash: triggerGetOrderByHash,
                        items: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.items,
                        orderDetails: orderDetails
                    })
                }) : null
            ]
        });
    };
    var getItemTotalForChildOrder = function() {
        var ref;
        return parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : (ref = parentOrderDetails.items) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, curr) {
            if (curr.item_status === 1) acc = acc + curr.amount;
            return acc;
        }, 0);
    };
    /**
   * return the order process status text
   * @return {string}
   */ var getParentOrderStatusProcessText = function() {
        var processingText = {
            title: "",
            subtitle: ""
        };
        if ((parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED || (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.CONFIRMED_COD */.DF.CONFIRMED_COD) {
            processingText.title = "Order Placed";
            processingText.subtitle = "We have received your order.";
        } else if ((parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN && (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.digital_receipt) === "") {
            processingText.title = "Order Seen";
            processingText.subtitle = "We will get your order ready for pickup soon.";
        } else {
            if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_type) == constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP) {
                processingText.title = "Your Order is Ready for Pickup";
            } else processingText.title = isB2bTypeOrder ? "quotation has been Verified successfully" : "Your Order is Verified Successfully";
        }
        return processingText;
    };
    var _renderParentOrderStatusComplete = function() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.COMPLETED */.DF.COMPLETED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6 flex justify-start items-center",
                children: [
                    (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.prepaid_flag) !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/q1kVDpRv.webp",
                        className: "img h2 mr2"
                    }),
                    "Your Order is Complete.",
                    (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.prepaid_flag) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/q1kVDpRv.webp",
                        className: "img h2 mr2"
                    })
                ]
            }) : (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.REJECTED */.DF.REJECTED && (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.display_status) === constants/* DISPLAY_STATUS.REJECTED */.Uq.REJECTED ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/eJFFlBiC.webp",
                        className: "mb2 img h2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Your order has been rejected",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status_message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "f7 fw6 black-40",
                        children: parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status_message
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/KIE24hYi.webp",
                        className: "mb2 img h2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (ref = getParentOrderStatusProcessText()) === null || ref === void 0 ? void 0 : ref.title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && state.deliveryTracking.text && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "f7 fw6 black-40",
                        children: state.deliveryTracking.text
                    })
                ]
            })
        });
    };
    /**
   * Return JSX for
   * Order Status Processing
   * @return {JSX}
   */ var _renderParentOrderStatusProccessing = function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "order-status__processing",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "order-status__processing--top",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "title-text",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "f5 fw6",
                                    children: (ref = getParentOrderStatusProcessText()) === null || ref === void 0 ? void 0 : ref.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "f7 fw5 gray",
                                    children: (ref1 = getParentOrderStatusProcessText()) === null || ref1 === void 0 ? void 0 : ref1.subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                            className: "status",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "f7 fw6 pv2 mr2 flex justify-start items-center pointer",
                                onClick: toggleStatusBlock,
                                children: [
                                    "Check Status",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "dropdown button",
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                        className: "h2 img ml2 ".concat(state.isStatusBlockVisible ? "arrow-up" : "arrow-down")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                state.isStatusBlockVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "order-status__processing--bottom pt4 pb3 ph1 flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-column items-center f7 fw6 mw4 h-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/7pzKCEUO.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Order Placed"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-column justify-center items-center tc f7 fw6 mw4 h-100",
                            children: [
                                (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/7pzKCEUO.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/quONXE2Z.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Order Seen",
                                ((parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED || (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.CONFIRMED_COD */.DF.CONFIRMED_COD) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "o-30 f8 mt2",
                                    children: "Order is yet to be seen."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex flex-column items-center f7 fw6 m4 h-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/quONXE2Z.webp",
                                    alt: "tick",
                                    className: "h2 img z-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_type) === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Ready for ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Pickup",
                                        " "
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Out for ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " Delivery"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var _renderOrderStatusForParentOrder = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "order-status",
            children: !((parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.ORDER_SEEN */.DF.ORDER_SEEN || (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.ORDER_PLACED */.DF.ORDER_PLACED || (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.status) === constants/* ORDER_STATUS.CONFIRMED_COD */.DF.CONFIRMED_COD) ? _renderParentOrderStatusComplete() : _renderParentOrderStatusProccessing()
        });
    };
    var _renderBillForChildOrder = function() {
        var ref, ref1, ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "order-bill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "items-details-container",
                    children: parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : (ref = parentOrderDetails.items) === null || ref === void 0 ? void 0 : ref.map(function(item, ind) {
                        var savingAmt = (item === null || item === void 0 ? void 0 : item.actual_amount) * (item === null || item === void 0 ? void 0 : item.quantity) - item.amount;
                        return item.item_status === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "bill-table bill-items-margin",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fw4 item-name-container responsive-major-text",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-column",
                                            children: [
                                                item === null || item === void 0 ? void 0 : item.item_name,
                                                " X ",
                                                item === null || item === void 0 ? void 0 : item.quantity,
                                                (item === null || item === void 0 ? void 0 : item.variant_name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "mt4px star-dust responsive-minor-text",
                                                    children: [
                                                        " ",
                                                        item === null || item === void 0 ? void 0 : item.variant_name,
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        item.additional_remark ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-column f12px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt3 mb0 fw4 tile-gray-color",
                                                    children: "Additional Remarks:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "mt1 fw4 mb0",
                                                    children: [
                                                        '"',
                                                        item.additional_remark,
                                                        '"'
                                                    ]
                                                })
                                            ]
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-column fw4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "flex justify-end",
                                            children: (item === null || item === void 0 ? void 0 : item.item_type) !== "list" ? "₹ ".concat(item === null || item === void 0 ? void 0 : item.discounted_price) : "-"
                                        }),
                                        (item === null || item === void 0 ? void 0 : item.item_type) !== "list" && savingAmt > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "fw4 mt4px color-green responsive-minor-text",
                                            children: [
                                                config/* CURRENCY_SYMBOL */.o,
                                                "\xa0",
                                                savingAmt === null || savingAmt === void 0 ? void 0 : savingAmt.toFixed(2),
                                                " Saved"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, "order-item-".concat(ind)) : null;
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "overall-details-wrapper sonic-silver",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "bill-table",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fw4 f7",
                                    children: (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_type) === constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE ? "Total" : "Item Total"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fw4 f7 tr",
                                    children: [
                                        "₹\xa0",
                                        (ref1 = getItemTotalForChildOrder()) === null || ref1 === void 0 ? void 0 : ref1.toFixed(2)
                                    ]
                                })
                            ]
                        }),
                        (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && Number(parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.delivery_charge) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "bill-table mt10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fw4 f7",
                                    children: "Delivery fees"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fw4 f7 tr",
                                    children: [
                                        "₹\xa0",
                                        Number(parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.delivery_charge)
                                    ]
                                })
                            ]
                        }),
                        (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && Number(parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.cod_charges) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "bill-table mt10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fw4 f7",
                                    children: "Extra Charges on COD"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fw4 f7 tr",
                                    children: [
                                        "₹\xa0",
                                        Number(parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.cod_charges)
                                    ]
                                })
                            ]
                        }),
                        (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.extra_charges) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "bill-table mt10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fw4 f7",
                                    children: [
                                        parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.extra_charge_name.substr(0, 20),
                                        (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.extra_charge_name.length) > 20 && "..."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fw4 f7 tr",
                                    children: [
                                        "₹\xa0",
                                        parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.extra_charges
                                    ]
                                })
                            ]
                        }),
                        (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "bill-table mt10px color-green",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fw4 f7",
                                    children: "Discount"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fw4 f7 tr",
                                    children: [
                                        "- ₹\xa0",
                                        parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.discount
                                    ]
                                })
                            ]
                        }),
                        (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.promo_discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "bill-table mt10px color-green",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fw4 f7",
                                    children: "Promo Discount"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fw4 f7 tr",
                                    children: [
                                        "- ₹\xa0",
                                        parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.promo_discount
                                    ]
                                })
                            ]
                        }),
                        isParentOrderGstExcluded() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "bill-table mt10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fw4 f7",
                                    children: "GST"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fw4 f7 tr",
                                    children: [
                                        "₹\xa0",
                                        parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.total_gst_paid
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "conclusion",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "fw6 responsive-major-text",
                                    children: [
                                        "Grand Total",
                                        isParentOrderGstIncluded() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "incl-gst responsive-minor-text fw4 ml6px",
                                            children: [
                                                "(Incl. ₹ ",
                                                parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.total_gst_paid,
                                                " GST)"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "fw6 pay-amount responsive-major-text",
                                    children: [
                                        "₹\xa0",
                                        parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : (ref2 = parentOrderDetails.part_payment_info) === null || ref2 === void 0 ? void 0 : ref2.total_payable_amount
                                    ]
                                })
                            ]
                        }),
                        (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.offer_text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-start items-center f7 fw4 pv1 mr5",
                            dangerouslySetInnerHTML: {
                                __html: parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.offer_text
                            }
                        }) : null
                    ]
                })
            ]
        });
    };
    var isThisCfeSideParentOrder = function() {
        return [
            1,
            2
        ].includes(parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.order_type);
    };
    var _renderParentOrderStatusforAppSideOrders = function() {
        return !(0,isOrderPending/* isOrderPending */.m)(parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.display_status) && (parentOrderDetails === null || parentOrderDetails === void 0 ? void 0 : parentOrderDetails.display_status) !== constants/* DISPLAY_STATUS.REJECTED */.Uq.REJECTED ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "order-status",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "tc fw6 mb2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/7pzKCEUO.webp",
                        className: "mb2 img h3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Your have paid ₹",
                    parentOrderDetails.pay_amount
                ]
            })
        }) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "premium-order-status-page",
        children: [
            deviceWidth/* deviceWidth */.o > constants/* MAX_MOBILE_WIDTH */.Cf && ((ref = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            })),
            thankYouHeader(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "pb6",
                children: [
                    loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pa3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OrderStatusLoader, {})
                    }) : isOrderChildPartialPaymentType() ? renderOrderDetailComponentWhenChildOrder() : (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) !== constants/* ORDER_STATUS.PAYMENT_PENDING */.DF.PAYMENT_PENDING || isB2bTypeOrder ? orderDetailComponent() : noOrderDetailsFound(),
                    isB2bTypeOrder && renderB2bRfqDetails()
                ]
            }),
            footerComponent(),
            deviceWidth/* deviceWidth */.o > 990 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopPaymentModal/* default */.ZP, {}),
            showAuthModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal, {
                toggleModal: toggleAuthModal,
                isVisible: showAuthModal,
                callback: function() {
                    return window.location.reload();
                }
            })
        ]
    });
};
/* harmony default export */ var containers_OrderStatus = (OrderStatus);


/***/ }),

/***/ 652219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ isOrderPending; }
/* harmony export */ });
/**
 * @param {string} orderStatus
 * @return {boolean}
 */ var isOrderPending = function(orderStatus) {
    switch(orderStatus){
        case "completedOnline":
        case "completedCash":
        case "cashMarked":
        case "paidOnline":
        case "rejected":
        case "prepaidDeliveryCompleted":
        case "prepaidPickupCompleted":
        case "prepaidPickupReady":
        case "prepaidDeliveryReady":
        case "markReady":
        case "outForDelivery":
            return false;
        case "new":
        case "billSent":
        case "sendBill":
            return true;
        default:
            return true;
    }
};


/***/ }),

/***/ 394421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reviewOrderItemsContainer":"ReviewOrderItems_reviewOrderItemsContainer__ZDDbe","orderItem":"ReviewOrderItems_orderItem__u4CZf","gap":"ReviewOrderItems_gap__xch4f","verticalLine":"ReviewOrderItems_verticalLine__BrXTM","writeReview":"ReviewOrderItems_writeReview__vJQUr"};

/***/ })

}]);